import React from 'react';
import Helmet from 'react-helmet';
import FirefoxIcon from '../assets/images/firefox-icon.png';
import Firefox_default from '../assets/images/firefox_default_search_walkthrough.png';

const Firefox = () => (
  <div>
    <Helmet>
      <title>Firefox Default Search Walkthrough - {process.env.REACT_APP_NAME}</title>
      <meta name="description" content="" />
    </Helmet>

    <div className="main-container -uninstall">
      <h2 className="uninstall-bodyhead">
        <img className="image" src={FirefoxIcon} alt="firefox-icon" />
        <span className="head">Set Search Administrator as Default Search Engine</span>
      </h2>

      <ol className="uninstall-list">
        <li>
          <p>Click the Firefox menu on the browser toolbar.</p>
        </li>
        <li>
          <p>
            Click <strong>'Options'</strong> and select <strong>'Search'</strong>.
          </p>
        </li>
        <li>
          <p>
            Choose <strong>Search Administrator</strong> as default search engine.
          </p>
        </li>
      </ol>
      <p>
        <img className="image_walkthrough" src={Firefox_default} alt="chrome-menu" />
      </p>
    </div>
  </div>
);

export default Firefox;



// WEBPACK FOOTER //
// ./src/pages/Firefox.js